import { DSButtonV2 } from '@elliemae/ds-button-v2';
import { styled } from '@elliemae/ds-system';
import { DSControlledDateTimePickerName, DSControlledDateTimePickerSlots } from '../../../constants/index.js';
import { CalendarContent } from '../Calendar/CalendarContent.js';

export const StyledIconTriggerButton = styled(DSButtonV2, {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.PICKER_ICONS.CALENDAR_TIMEWHEEL,
})`
  color: ${({ theme }) => theme.colors.brand['800']};
  width: 2rem;
  height: 2rem;
`;

export const StyledCalendarWithTimeWheelWrapper = styled('div', {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.CONTROLLER_COMPONENT.CALENDAR_TIMEWHEEL,
})<{ $readOnlyStyles?: boolean }>`
  background: ${({ theme, $readOnlyStyles }) =>
    $readOnlyStyles ? theme.colors.neutral['050'] : theme.colors.neutral['000']};
  display: grid;
  grid-template-columns: 260px 192px;
  grid-template-rows: 1fr;
  // this gap and background color simulate the border separator between the calendar and time wheel
  column-gap: 1px;
  background-color: ${({ theme }) => theme.colors.neutral['200']};
`;

export const StyledCalendar = styled(CalendarContent)`
  box-shadow: none;
`;

export const CalendarWithTimeWheelFooterMessage = styled('div', {
  name: DSControlledDateTimePickerName,
  slot: DSControlledDateTimePickerSlots.FOOTERS.CALENDAR_TIMEWHEEL,
})<{ $readOnlyStyles?: boolean }>`
  border-top: solid 1px ${({ theme }) => theme.colors.neutral[300]};
  padding: ${({ theme }) => theme.space.xxs2};
  color: ${({ theme }) => theme.colors.danger[900]};
  font-size: ${({ theme }) => theme.fontSizes.microText[200]};
  text-align: right;
  grid-column: 1/3;
  background-color: ${({ theme, $readOnlyStyles }) =>
    $readOnlyStyles ? theme.colors.neutral['050'] : theme.colors.neutral['000']};
`;
